import { mount } from "svelte";
import "./app.css";
import App from "./App.svelte";
import * as Sentry from "@sentry/svelte";

Sentry.init({
  dsn: "https://74a725d1ee62fd92c2285534fd04226d@o106966.ingest.us.sentry.io/4509332046610432",
  // Setting this option to true will send default PII data to Sentry.
  // For example, automatic IP address collection on events
  sendDefaultPii: true,
});

const app = mount(App, {
  target: document.getElementById("app"),
});

export default app;
